// extracted by mini-css-extract-plugin
module.exports = {"container":"StoreAvailabilityToggles_container__1A7_L","storeToggle":"StoreAvailabilityToggles_storeToggle__Q5egm","editLink":"StoreAvailabilityToggles_editLink__edJMF"};